import './main.scss';
import React from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import RoleRibbonByRole from '../../../organisms/common/role-ribbon/role-ribbon-by-role';
import { getAuthToken, getCurrentRole } from '../../../../utils/auth';
import { canAccessClientPreview } from '../../../../utils/role-utils';

import Footer from "../../../organisms/footer/footer";

import ProductCatalog from "../../../organisms/common/products/catalog";
import {useTranslation} from "react-i18next";


const HacProductCatalog = () => {
  window.scroll(0, 0);
  const token = getAuthToken();
  const role = getCurrentRole(token);

  const navigate = useNavigate();
  const {t} = useTranslation();

  return (
    <>
      {token && (role === 'hac' || role === 'pmaGM' || role === 'pma' || role === 'retailerGM' || role === 'retailer' || canAccessClientPreview(role)) ? (
        <div className="App">
          <Header/>
          <main className="landing product">
            <RoleRibbonByRole role={role} navigate={navigate} translate={t} context="clientView" />
            <section className="gallery catalog">

                <ProductCatalog></ProductCatalog>

            </section>

          </main>
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}

    </>
  );
};

export default HacProductCatalog;
